export const regulatorKeys = {
  FCA: 'fca',
  ESMA: 'esma'
};

export const regulatorLabels = {
  [regulatorKeys.FCA]: 'FCA',
  [regulatorKeys.ESMA]: 'ESMA'
};

export const regulatorsList = [
  {
    value: regulatorKeys.FCA,
    name: regulatorLabels[regulatorKeys.FCA]
  },
  {
    value: regulatorKeys.ESMA,
    name: regulatorLabels[regulatorKeys.ESMA]
  }
];
